export const inputNumberCheckHandler = (value: string): boolean => {
  const floatRegexp = /^[0-9]*?[.]?[0-9]*?$/;

  return floatRegexp.test(value);
};